import { ICrudFetchOptions } from 'clickNgo/models/crud/utils'
import { IAttachment } from 'clickNgo/models/file'

import { fetchLegalFileByPartnerId } from './fetchLegalFileByPartnerId'
import { mapLegalAttachmentsFromFileData } from './mapping/mapLegalAttachmentsFromFileData'

export const fetchPartnerAttachmentsById = (
  partnerId: string,
  options?: ICrudFetchOptions
): Promise<IAttachment[]> => {
  if (!partnerId) {
    return Promise.resolve([])
  }

  return fetchLegalFileByPartnerId(partnerId, options).then(mapLegalAttachmentsFromFileData)
}
